import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutMainSetResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutMainSetResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutMainSetResponse) {
    JsonSchemaValidator.assert(
      RoomStageLayoutMainSetResponseDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

export interface RoomStageLayoutMainSetResponseJson {
  roomId: RoomId;
  streamId: StreamId;
}

interface RoomStageLayoutMainSetResponse {
  roomId: RoomId;
  streamId: StreamId;
}
